import React, {useEffect, useState} from 'react';
import EditModal from "@core/modals/EditModal";
import EditButton from "@core/buttons/atoms/EditButton";
import Input from "@core/inputs/Input";
import {showError, showSuccess} from "@utils/helpers";
import {useTranslation} from "react-i18next";
import PermissionHandler from "@hoc/cruds/PermissionHandler";
import OwnerService from "@services/OwnerService";
import CompanyTypeSelect from "@components/CompanyType/partials/CompanyTypeSelect";
import NumericalInput from "@core/inputs/NumericalInput";
import CountrySelect from "@components/Country/partials/CountrySelect";
import CaptaincySelect from "@components/Captaincy/partials/CaptaincySelect";
import MinorStrataSelect from "@components/MinorStrata/partials/MinorStrataSelect";

const EditOwner = ({owner, onEdited}) => {
  const {t} = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [companyType, setCompanyType] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [establishmentYear, setEstablishmentYear] = useState('');
  const [address, setAddress] = useState('');
  const [postCode, setPostCode] = useState('');
  const [town, setTown] = useState('');
  const [region, setRegion] = useState('');
  const [country, setCountry] = useState('');
  const [registrationOffice, setRegistrationOffice] = useState('');
  const [remarks, setRemarks] = useState('');

  const closeModal = () => {
    setShowModal(false)
    setCompanyType(null);
    setCompanyName('');
    setEstablishmentYear('');
    setAddress('');
    setPostCode('');
    setTown('');
    setRegion('');
    setCountry(null);
    setRegistrationOffice(null);
    setRemarks('');
  }

  const onSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    OwnerService.update(owner.id, companyType, companyName, establishmentYear === -1 ? undefined : establishmentYear, address, postCode, town, region, country ? country : undefined, registrationOffice, remarks).then(() => {
      showSuccess(t('ownerEditedSuccessfully'));
      onEdited()
      closeModal();
    })
      .catch((err) => {
        showError(err.response.data.message);
      })
      .finally(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    if (showModal)
      OwnerService.find(owner.id).then((response) => {
        setCompanyType(response.data.data.company_type_id);
        setCompanyName(response.data.data.company_name);
        setEstablishmentYear(response.data.data.established_year);
        setAddress(response.data.data.address);
        setPostCode(response.data.data.postcode);
        setTown(response.data.data.town);
        setRegion(response.data.data.region_id);
        setCountry(response.data.data.country_id);
        setRegistrationOffice(response.data.data.registration_office_id);
        setRemarks(response.data.data.remarks)
      });
  }, [owner.id, showModal]);

  useEffect(() => {
    if (country !== "3") {
      setRegion(null)
    }
  }, [country])

  return (
    <PermissionHandler permission={'update_owner'}>
      <EditButton onClick={() => setShowModal(true)}/>
      <EditModal
        show={showModal}
        title={t('ediOwner')}
        onClose={closeModal}
        onSubmit={onSubmit}
        loading={loading}
        label={t('edit')}
      >
        <div className='mt-4 sm:mt-8 mb-2 grid grid-cols-2 gap-5'>
          <div>
            <div className="text-xs font-semibold mb-2 flex">
              {t('companyType')}
            </div>
            <CompanyTypeSelect
              openModal={showModal}
              onSelect={setCompanyType}
              selected={companyType}
            />
          </div>
          <Input
            height='h-10'
            label={t('companyName')}
            placeholder={t('companyName')}
            value={companyName}
            onChange={setCompanyName}
          />
          <NumericalInput
            height='h-10'
            label={t('establishedYear')}
            placeholder={t('establishedYear')}
            value={establishmentYear}
            onChange={setEstablishmentYear}
          />
          <div>
            <div className="text-xs font-semibold mb-2 flex">
              {t('registrationOffice')}
            </div>
            <CaptaincySelect
              openModal={showModal}
              onSelect={setRegistrationOffice}
              selected={registrationOffice}
            />
          </div>
          <Input
            height='h-10'
            label={t('address')}
            placeholder={t('address')}
            value={address}
            onChange={setAddress}
          />
          <Input
            height='h-10'
            label={t('postcode')}
            placeholder={t('postcode')}
            value={postCode}
            onChange={setPostCode}
          />
          <Input
            height='h-10'
            label={t('town')}
            placeholder={t('town')}
            value={town}
            onChange={setTown}
          />
          <div>
            <div className="text-xs font-semibold mb-2 flex">
              {t('region')}
            </div>
            <MinorStrataSelect
              disabled={country !== '3'}
              openModal={showModal}
              onSelect={setRegion}
              selected={region}
            />
          </div>
          <div>
            <div className="text-xs font-semibold mb-2 flex">
              {t('country')}
            </div>
            <CountrySelect
              openModal={showModal}
              onSelect={setCountry}
              selected={country}
            />
          </div>
          <Input
            height='h-10'
            label={t('remarks')}
            placeholder={t('remarks')}
            value={remarks}
            onChange={setRemarks}
          />
        </div>
      </EditModal>
    </PermissionHandler>

  )
}

export default EditOwner;